import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Container,
  Row,
  Card,
  Col,
  Modal,
  Form,
  Button,
  Offcanvas,
  Badge,
} from "react-bootstrap";
import DataTable from "react-data-table-component";
import Breadcrumb from "Common/BreadCrumb";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useAddSmSMutation,
  useDeleteSmsEnAttenteMutation,
  useFetchAllSmSQuery,
  useSendSmSMutation,
} from "features/smsEnseignants/smsEnseignantSlice";
import Select from "react-select";
import shortCode from "Common/shortCode";
import { useFetchEnseignantsQuery } from "features/enseignants/enseignantSlice";

const EnseignantsSmses = () => {
  const { data = [] } = useFetchAllSmSQuery();

  const { data: AllEnseignants = [] } = useFetchEnseignantsQuery();

  const pending_sms = data.filter((sms) => sms.status === "Pending");

  const [showDestinataire, setShowDestinataire] = useState<boolean>(false);

  const notifySuccess = () => {
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Message a été créé avec succès",
      showConfirmButton: false,
      timer: 2500,
    });
  };

  const notifyError = (err: any) => {
    Swal.fire({
      position: "center",
      icon: "error",
      title: `Une erreur est survenue: ${err}`,
      showConfirmButton: false,
      timer: 2500,
    });
  };
  const [
    deleteSmsEnAttente,
    { isLoading: isDeletingPendingSmsLoading, isError },
  ] = useDeleteSmsEnAttenteMutation();
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });

  const AlertDelete = async () => {
    swalWithBootstrapButtons
      .fire({
        title: "Etes-vous sûr?",
        text: "Vous ne pouvez pas revenir en arrière?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui, supprime-le !",
        cancelButtonText: "Non, annuler !",
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteSmsEnAttente();
          swalWithBootstrapButtons.fire(
            "Supprimé !",
            "Les SMS en attente ont été supprimés avec succès.",
            "success"
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            "Annulé",
            "Les SMS en attente sont sécurisés :)",
            "info"
          );
        }
      });
  };

  const [modal_AddSms, setmodal_AddSms] = useState<boolean>(false);
  function tog_AddSms() {
    setmodal_AddSms(!modal_AddSms);
  }

  const [createSms] = useAddSmSMutation();

  const [sendSms, { isLoading }] = useSendSmSMutation();

  const handleReload = () => {
    window.location.reload();
  };

  const handleSendSms = async () => {
    try {
      await sendSms().then(() => handleReload);
    } catch (error) {
      console.error("Error sending SMS:", error);
    }
  };

  const initialSms = {
    sender: "",
    msg: "",
    status: "",
    include_names: "1",
    specefic_enseignants: [""],
    total_sms: "",
    sms_par_destinataire: "",
  };

  const [sms, setSms] = useState(initialSms);

  const {
    sender,
    msg,
    status,
    include_names,
    specefic_enseignants,
    total_sms,
    sms_par_destinataire,
  } = sms;

  const optionEnseignant = AllEnseignants.map((enseignant: any) => ({
    value: enseignant?._id!,
    label: `${enseignant?.prenom_enseignant!} ${enseignant?.nom_enseignant!} ___${" "} ${enseignant?.matiere!}`,
  }));

  const [selectedEnseignant, setSelectedEnseignant] = useState<any[]>([]);

  const handleSelectEnseignant = async (selectedOption: any) => {
    const values = selectedOption.map((option: any) => option.value);
    setSelectedEnseignant(values);
  };

  useEffect(() => {
    setSms((prevState) => ({
      ...prevState,
      specefic_enseignants: selectedEnseignant,
    }));
  }, [AllEnseignants, selectedEnseignant]);

  const onChangeSms = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSms((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const calculateSmsCount = (messageLength: number) => {
    return messageLength <= 157
      ? 1
      : Math.ceil((messageLength - 157) / 158) + 1;
  };

  const numberOfSms = calculateSmsCount(msg.length);
  let totalSms = numberOfSms * specefic_enseignants.length;
  const onSubmitSms = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      sms["sender"] = "SLS Sousse";
      sms["status"] = "Pending";
      sms["total_sms"] = totalSms.toString();
      sms["sms_par_destinataire"] = numberOfSms.toString();
      createSms(sms)
        .then(() => notifySuccess())
        .then(() => setSms(initialSms));
    } catch (error) {
      notifyError(error);
    }
  };

  const groupedData = Object.values(
    data.reduce((acc: any, current: any) => {
      const { msg } = current;

      if (!acc[msg]) {
        acc[msg] = {
          ...current,
          receiversCount: [current],
        };
      } else {
        acc[msg].receiversCount.push(current);
      }
      return acc;
    }, {})
  );

  // Search
  const [searchTerm, setSearchTerm] = useState("");
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const getFilteredData = () => {
    let filtered = [...groupedData].reverse();
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter((row: any) =>
        row.msg?.toLowerCase().includes(term) ||
        row.createdAt?.toLowerCase().includes(term) ||
        row.status?.toLowerCase().includes(term) ||
        String(row.receiversCount?.length || "").includes(term)
      );
    }
    return filtered;
  };

  // Stats
  const stats = useMemo(() => {
    const sent = data.filter((s: any) => s.status === "sent").length;
    const pending = data.filter((s: any) => s.status === "Pending").length;
    return { total: data.length, sent, pending };
  }, [data]);

  const columns = [
    {
      name: <span className="fw-semibold fs-13">Message</span>,
      selector: (row: any) => row.msg,
      cell: (row: any) => (
        <span className="text-muted fs-13 text-truncate d-inline-block" style={{ maxWidth: 350 }}>
          <i className="ri-message-2-line me-1 text-primary" />
          {row.msg}
        </span>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: <span className="fw-semibold fs-13">Destinataire(s)</span>,
      selector: (row: any) => row.receiversCount?.length || 0,
      cell: (row: any) => (
        <Link
          to="#"
          state={row}
          onClick={() => setShowDestinataire(!showDestinataire)}
          className="text-decoration-none"
        >
          <Badge bg="primary-subtle" text={"primary" as any} className="fs-12 px-2 py-1">
            <i className="ri-group-line me-1" />
            {row.receiversCount.length}
          </Badge>
        </Link>
      ),
      sortable: true,
      width: "12%",
    },
    {
      name: <span className="fw-semibold fs-13">Etat</span>,
      selector: (row: any) => row.status,
      cell: (row: any) => {
        switch (row.status) {
          case "Pending":
            return (
              <Badge bg="warning-subtle" text={"warning" as any} className="fs-12 px-2 py-1">
                <i className="ri-time-line me-1" />
                En Attente
              </Badge>
            );
          case "sent":
            return (
              <Badge bg="success-subtle" text={"success" as any} className="fs-12 px-2 py-1">
                <i className="ri-check-double-line me-1" />
                Envoyé
              </Badge>
            );
          default:
            return (
              <Badge bg="warning-subtle" text={"warning" as any} className="fs-12 px-2 py-1">
                <i className="ri-time-line me-1" />
                En Attente
              </Badge>
            );
        }
      },
      sortable: true,
      width: "12%",
    },
    {
      name: <span className="fw-semibold fs-13">Actions</span>,
      cell: (row: any) => (
        <div className="d-flex gap-1">
          <Link
            to="#"
            state={row}
            className="btn btn-soft-info btn-sm btn-icon"
            onClick={() => setShowDestinataire(true)}
            title="Voir destinataires"
          >
            <i className="ri-eye-line" />
          </Link>
        </div>
      ),
      width: "8%",
    },
  ];

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const destinataireLocation = useLocation();

  const handleShortcodeClick = (code: string) => {
    if (textareaRef.current) {
      const textarea = textareaRef.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const newText = msg.slice(0, start) + code + msg.slice(end);

      setSms((prevState) => ({
        ...prevState,
        msg: newText,
      }));

      setTimeout(() => {
        textarea.setSelectionRange(start + code.length, start + code.length);
        textarea.focus();
      }, 0);
    }
  };

  const filteredShortCode = shortCode.filter(
    (item) =>
      item.name.toLowerCase().includes("enseignant") ||
      item.code.toLowerCase().includes("enseignant")
  );

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f3f6f9",
        fontWeight: "600",
        fontSize: "13px",
        color: "#495057",
        borderBottom: "2px solid #e9ebec",
      },
    },
    rows: {
      style: {
        fontSize: "13px",
        "&:hover": {
          backgroundColor: "#f3f6f9",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ebec",
      },
    },
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="SMS Enseignants" pageTitle="Tableau de bord" />

          {/* KPI Cards */}
          <Row className="mb-3">
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                        <i className="ri-message-2-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Total Messages</p>
                      <h4 className="mb-0">{stats.total}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded-circle fs-3">
                        <i className="ri-check-double-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Envoyés</p>
                      <h4 className="mb-0 text-success">{stats.sent}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-warning-subtle text-warning rounded-circle fs-3">
                        <i className="ri-time-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">En Attente</p>
                      <h4 className="mb-0 text-warning">{stats.pending}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col sm={6} xl={3}>
              <Card className="card-animate border-0 shadow-sm">
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded-circle fs-3">
                        <i className="ri-user-star-line" />
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="text-uppercase fw-medium text-muted mb-1 fs-13">Enseignants</p>
                      <h4 className="mb-0 text-info">{AllEnseignants.length}</h4>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Data Table */}
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Header className="border-bottom-dashed bg-white">
                <Row className="g-3 align-items-center">
                  <Col lg={4} md={6}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Rechercher par message..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                  <Col lg={8} md={6} className="d-flex justify-content-end gap-2">
                    {pending_sms.length > 0 && (
                      <Button
                        variant="soft-danger"
                        size="sm"
                        onClick={AlertDelete}
                        disabled={isDeletingPendingSmsLoading}
                        className="d-flex align-items-center gap-1"
                      >
                        <i className="ri-delete-bin-2-line fs-16" />
                        {isDeletingPendingSmsLoading ? "Nettoyage..." : "Nettoyer en attente"}
                      </Button>
                    )}
                    {isLoading ? (
                      <Button variant="outline-primary" size="sm" disabled className="d-flex align-items-center gap-1">
                        <span className="spinner-border spinner-border-sm" role="status" />
                        En Cours...
                      </Button>
                    ) : (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={handleSendSms}
                        disabled={pending_sms.length === 0}
                        className="d-flex align-items-center gap-1"
                      >
                        <i className="ri-send-plane-line fs-16" />
                        Envoyer ({pending_sms.length})
                      </Button>
                    )}
                    <Button
                      variant="primary"
                      onClick={() => tog_AddSms()}
                      className="d-flex align-items-center gap-1"
                    >
                      <i className="ri-add-line fs-16" />
                      Nouveau message
                    </Button>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="p-0">
                <DataTable
                  columns={columns}
                  data={getFilteredData()}
                  pagination
                  paginationPerPage={15}
                  paginationRowsPerPageOptions={[10, 15, 25, 50]}
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center py-5">
                      <i className="ri-message-2-line fs-1 text-muted d-block mb-2" />
                      <p className="text-muted mb-0">Aucun message trouvé</p>
                    </div>
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                  }}
                  highlightOnHover
                  responsive
                />
              </Card.Body>
            </Card>
          </Col>

          {/* Add Modal */}
          <Modal
            className="fade"
            id="createModal"
            show={modal_AddSms}
            onHide={() => {
              tog_AddSms();
            }}
            centered
            size="xl"
          >
            <Modal.Header closeButton className="bg-primary-subtle">
              <h5 className="modal-title">
                <i className="ri-add-circle-line me-2" />
                Ajouter Message
              </h5>
            </Modal.Header>
            <Modal.Body>
              <Form className="create-form" onSubmit={onSubmitSms}>
                <Row className="mb-4">
                  <Col lg={2}>
                    <Form.Label htmlFor="enseignant">Enseignant(s)</Form.Label>
                  </Col>
                  <Col lg={7}>
                    <Select
                      closeMenuOnSelect={false}
                      isMulti
                      options={optionEnseignant}
                      onChange={handleSelectEnseignant}
                      placeholder="Choisir..."
                    />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col lg={2}>
                    <Form.Label htmlFor="msg">Message</Form.Label>
                  </Col>
                  <Col lg={7}>
                    <small className="text-muted">
                      Vous pouvez utiliser les abréviations dynamiques
                    </small>
                    <textarea
                      className="form-control"
                      id="msg"
                      name="msg"
                      value={sms.msg}
                      onChange={onChangeSms}
                      ref={textareaRef}
                      rows={8}
                    ></textarea>
                    <div className="mt-2 text-end">
                      <span>
                        {msg.length}/ {numberOfSms} SMS
                      </span>
                    </div>
                  </Col>
                  <Col lg={2}>
                    {filteredShortCode.map((code) => (
                      <Button
                        type="button"
                        variant="light"
                        id="addNew"
                        className="mb-2"
                        onClick={() => handleShortcodeClick(code.code)}
                      >
                        {code.name}
                      </Button>
                    ))}
                  </Col>
                </Row>
                <Row>
                  <div className="hstack gap-2 justify-content-end">
                    <Button
                      variant="light"
                      onClick={() => {
                        tog_AddSms();
                        setSms(initialSms);
                      }}
                    >
                      Fermer
                    </Button>
                    <Button
                      onClick={() => {
                        tog_AddSms();
                      }}
                      type="submit"
                      variant="success"
                      id="addNew"
                    >
                      <i className="ri-check-line me-1" />
                      Ajouter
                    </Button>
                  </div>
                </Row>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Destinataire Offcanvas */}
          <Offcanvas
            show={showDestinataire}
            onHide={() => setShowDestinataire(false)}
            placement="end"
            style={{ width: "420px" }}
          >
            <Offcanvas.Header closeButton className="border-bottom bg-light">
              <Offcanvas.Title className="d-flex align-items-center gap-2">
                <i className="ri-user-star-line text-primary fs-20" />
                Destinataire(s)
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {destinataireLocation?.state?.receiversCount!.map((msg: any, idx: number) => (
                <div key={idx} className="d-flex align-items-center gap-3 p-2 border-bottom border-bottom-dashed">
                  <div className="avatar-xs flex-shrink-0">
                    <div className="avatar-title bg-info-subtle text-info rounded-circle fs-14">
                      {msg.receiver?.prenom_enseignant?.[0]}{msg.receiver?.nom_enseignant?.[0]}
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <span className="fw-medium d-block fs-13">
                      {msg.receiver.prenom_enseignant}{" "}
                      {msg.receiver.nom_enseignant}
                    </span>
                  </div>
                  <span className="text-muted fs-12">
                    <i className="ri-phone-line me-1" />
                    {msg.receiver.phone}
                  </span>
                </div>
              ))}
            </Offcanvas.Body>
          </Offcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default EnseignantsSmses;
